import {
  tooltipPlacement,
  TooltipTrigger,
} from "@visiblethread/react-components";
import { CircleAlert } from "lucide-react";
import { element, oneOfType, string } from "prop-types";

import classes from "./CellErrorIcon.module.scss";

const CellErrorIcon = ({ message }) => {
  return (
    <TooltipTrigger
      classes={classes.cellError}
      content={message}
      placement={tooltipPlacement.top}
    >
      <CircleAlert data-testid="circle-icon" size={16} />
    </TooltipTrigger>
  );
};

CellErrorIcon.propTypes = {
  message: oneOfType([element, string]),
};

export default CellErrorIcon;
